import { render, staticRenderFns } from "./ReadOnlyServiceInfo.vue?vue&type=template&id=26286c10&"
import script from "./ReadOnlyServiceInfo.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyServiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports